import { gsap } from "gsap";

const postContainer = document.querySelector('.blog-container');
const postContentHeadings = postContainer.querySelectorAll('h1, h2, h3, h4, h5, h6');
let anchorsContainers = document.querySelectorAll('.post-anchors-container .post-anchors');

for (let heading of postContentHeadings) {
    let headingTitle = heading.textContent;

    if (!!headingTitle) {
        let headingID = headingTitle.toLowerCase().replace(/&| /g, "_");;
        heading.setAttribute('id', headingID)

        //Create new anchor link 
        let newAnchor = `<a href="#${headingID}" class="post-anchor" style="opacity:0;">${headingTitle}</a>`;

        //Add new anchor to anchors container el
        for (let anchorsContainer of anchorsContainers) {
            anchorsContainer.innerHTML += newAnchor
        }
    }
}
//Animate in all new anchors
let newAnchors = document.querySelectorAll('a.post-anchor');
if (!!newAnchors) {
    gsap.to(newAnchors, {opacity:1, stagger:0.15, delay:0.25});
}

//TODO: Highlight current section on scroll and move desktop arrow according to active section instead of each <a> getting an arrow